module.exports = __webpack_public_path__ + "d48124b93152bfcedb956c02b5d9bcd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/fotl-ladies-vneck-grey.jpg
// module id = 832
// module chunks = 0